/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'csrf-rule';

export const csrfRuleBreadcrumbTitle = `${prefix}.csrfRuleBreadcrumbTitle`;

export const ENGLISH = {
    [csrfRuleBreadcrumbTitle]: 'CSRF Rule',
};
